var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 56,
    viewBox: "0 0 28 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.5C17.0376 11.5 19.5 9.03757 19.5 6C19.5 2.96243 17.0376 0.5 14 0.5C10.9624 0.5 8.5 2.96243 8.5 6C8.5 9.03757 10.9624 11.5 14 11.5Z",
    fill: "#226BF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1066 16.131C21.9254 15.583 21.5758 15.1061 21.1077 14.7683C20.6396 14.4306 20.0768 14.2492 19.4996 14.25H8.49958C7.92244 14.2496 7.35987 14.4312 6.89185 14.7689C6.42382 15.1065 6.07416 15.5832 5.89258 16.131L0.392578 32.631L5.27383 34.2618L2.99958 44.5H8.49958V55.5H19.4996V44.5H24.9996L22.7253 34.259L27.6066 32.6283L22.1066 16.131Z",
    fill: "#226BF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.35f2a6a82e4ef94bd9abf660e35ff306.svg";
export { ForwardRef as ReactComponent };